'use client';

export interface Chip {
  key: string;       // e.g. 'price:25-50' or 'brand:Mira'
  label: string;     // e.g. '£25–£50' or 'Mira'
  onRemove: () => void;
}

export default function FilterChips({ chips, onClearAll }: { chips: Chip[]; onClearAll: () => void }) {
  if (chips.length === 0) return null;

  return (
    <div className="chips">
      {chips.map((c) => (
        <button
          key={c.key}
          type="button"
          className="chip"
          onClick={c.onRemove}
          aria-label={`Remove filter ${c.label}`}
        >
          <span>{c.label}</span>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      ))}
      {chips.length > 1 && (
        <button type="button" className="chip-clear" onClick={onClearAll}>
          Clear all
        </button>
      )}

      <style>{`
        .chips {
          display: flex;
          flex-wrap: wrap;
          gap: 0.4rem;
          align-items: center;
        }
        .chip {
          display: inline-flex;
          align-items: center;
          gap: 0.4rem;
          padding: 0.35rem 0.7rem;
          font-size: 0.8rem;
          font-family: inherit;
          font-weight: 500;
          background: var(--color-white);
          color: var(--color-text-primary);
          border: 1px solid var(--color-border);
          border-radius: 999px;
          cursor: pointer;
          transition: background 0.12s, border-color 0.12s;
        }
        .chip:hover {
          background: var(--color-off-white);
          border-color: var(--color-border-dark);
        }
        .chip svg { color: var(--color-text-muted); }
        .chip-clear {
          background: transparent;
          border: none;
          color: var(--color-primary);
          font-size: 0.8rem;
          font-weight: 600;
          font-family: inherit;
          cursor: pointer;
          padding: 0.35rem 0.5rem;
        }
        .chip-clear:hover { text-decoration: underline; }
      `}</style>
    </div>
  );
}
